// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /invite/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeInviteGetBody,
  typeInviteGetOutput200,
} from "../../sdk/invite/postInviteGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildInviteGetQueryKey(payload: typeInviteGetBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`inviteId:${JSON.stringify(payload.inviteId)}`);
  return ["post:invite:inviteGet", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeInviteGetOutput200,
    unknown,
    typeInviteGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useInviteGet(
  payload: typeInviteGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildInviteGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postInviteGet(payload),
    ...resolvedOptions,
  });
}
